
<div class="mt-1 app-left-margin app-right-margin w-100" v-resize="onResize">
    <d-site
        v-if      = "unit.selected"
        v-model   = "unit.show"
        :site-id  = "unit.selected.id"
    />

    <company-app-bar
        title       = "DOKUMENTE"
        :categories = "[]"
        @search     = "() => {}"
    />

    <div class="document-container" >
        <v-row class="no-frame">
            <v-col class="no-border col-3">
                <p-dms-treeview-card-header
                    class="mt-n1"
                    @customer = "onCustomers"
                    @expand   = "onExpandFilter"
                />

                <p-dms-treeview-card-body
                    class     = "lm-border pt-1"
                    style     = " width: calc(100% - 8px); margin-top: 5px"
                    :style    = "bodyStyle"
                    :customer = "customer"
                    :height   = "height"
                    @unit     = "onSite"
                    @selected = "onSelected"
                />
            </v-col>
            <v-col class="mt-n2 no-border col-9">
                <c-dms-treeview-unit
                    class      = "pr-1 mr-2"
                    v-if       = "unit.selected"
                    :unit      = "unit.selected"
                    :height    = "height-2"
                    :col-width = "['col-1', 'col-2']"
                />
            </v-col>
        </v-row>
    </div>
</div>
